import {A11yModule} from '@angular/cdk/a11y';
import {ButtonModule} from "./button/button.module";
import {CheckboxGroupModule} from './checkbox-group/checkbox-group.module';
import {CommonModule} from '@angular/common';
import {DatepickerModule} from './datepicker/datepicker.module';
import {InputDirective} from './input.directive';
import {InputFileModule} from "./file/input-file.module";
import {InputGroupModule} from './input-group/input-group.module';
import {InputSearchDirective} from './search/input-search.directive';
import {LabelModule} from './label/label.module';
import {NameInputDirective} from "./format/name-input.directive";
import {NgModule} from '@angular/core';
import {PhoneNumberInputDirective} from "./format/phone-number-input.directive";
import {PostalCodeInputDirective} from "./format/postalcode-input.directive";
import {RadioModule} from './radio/radio.module';
import {TranslateModule} from '@ngx-translate/core';
import {ValgTimeInputDirective} from "./input-time/valg-time-input.directive";
import {FormPasswordModule} from "./password/password.module";
import { FormHintModule } from './hint/hint.module';
import { ValgTextAreaInputDirective } from './input-textarea/valg-textarea-input.directive';
import { MultiInputFileModule } from './multi-file/multi-input-file.module';

@NgModule({
  declarations: [
    InputDirective,
    InputSearchDirective,
    ValgTimeInputDirective,
    NameInputDirective,
    PhoneNumberInputDirective,
    PostalCodeInputDirective,
    ValgTextAreaInputDirective
  ],
  imports: [
    CommonModule,
    InputGroupModule,
    TranslateModule,
    A11yModule,
    LabelModule,
    FormHintModule,
    CheckboxGroupModule,
    RadioModule,
    DatepickerModule,
    InputFileModule,
    MultiInputFileModule,
    ButtonModule,
    FormPasswordModule
  ],
  exports: [
    InputGroupModule,
    MultiInputFileModule,
    LabelModule,
    FormHintModule,
    RadioModule,
    CheckboxGroupModule,
    InputDirective,
    InputSearchDirective,
    DatepickerModule,
    ValgTimeInputDirective,
    NameInputDirective,
    PhoneNumberInputDirective,
    PostalCodeInputDirective,
    ValgTextAreaInputDirective,
    InputFileModule,
    ButtonModule,
    FormPasswordModule,
  ]
})
export class ValgInputModule {}
